var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_567_1450)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.1875 11.6875L13.4654 11.6875L10.6315 14.52C10.3634 14.7881 10.3634 15.2213 10.6315 15.4963C10.9003 15.7644 11.3355 15.7644 11.6043 15.4963L15.4935 11.605C15.6578 11.44 15.7094 11.2131 15.6716 11C15.7094 10.7869 15.6578 10.56 15.4935 10.395L11.6043 6.50372C11.3355 6.2356 10.9003 6.2356 10.6315 6.50372C10.3634 6.77185 10.3634 7.21188 10.6315 7.48L13.4654 10.3125L6.1875 10.3125C5.808 10.3125 5.5 10.6219 5.5 11C5.5 11.3781 5.808 11.6875 6.1875 11.6875ZM11 1.375C16.3158 1.375 20.625 5.68563 20.625 11C20.625 16.3144 16.3158 20.625 11 20.625C5.68425 20.625 1.375 16.3144 1.375 11C1.375 5.68563 5.68425 1.375 11 1.375ZM11 22C17.0748 22 22 17.0775 22 11C22 4.9225 17.0748 0 11 0C4.92525 0 0 4.9225 0 11C0 17.0775 4.92525 22 11 22Z",
    fill: "#BBBBBB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_567_1450"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "matrix(-1 0 0 -1 22 22)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.d0b916031df1d59e71cde7b6f3759073.svg";
export { ForwardRef as ReactComponent };